<app-header-actions></app-header-actions>
<iframe [src]="url | safe" width="100%" height="{{dynamicHeight}}px" style="Border-style: hidden;"></iframe>